
import ReasoningItem from './reasoning-item.vue'

export default {
  components: {ReasoningItem},
  props: {
    items: {type: Array, required: true},
    completed: {type: Boolean, default: false}
  },
  data() {
    return {
      show_thumb: false,
      on_bottom: false
    }
  },
  methods: {
    scrollToItem(item) {
      const scroller = this.$refs.scroller
      if (!scroller) return
      scroller.refresh()
      const content = scroller.getContent()
      const viewport = content.getBoundingClientRect()
      const bounds = item.getBoundingClientRect()
      const above = bounds.top - viewport.top
      const below = bounds.bottom - (viewport.top + content.clientHeight)
      let offset = 0
      if (above < 0) offset = above
      else if (below > 0) offset = Math.min(above, below)
      if (!offset) return
      scroller.abortScrolling()
      scroller.scrollTop(Math.max(0, content.scrollTop + offset), {smooth: true})
    },
    checkBottom(){
      this.on_bottom = this.$refs.scroller?.checkBottom() ?? false
    },
    async onNewItem(){
      if (this.on_bottom) this.afterEnter()
    },
    afterEnter(){
      this.show_thumb = true
      if (!this.completed) this.scrollToLastItem()

    },
    scrollToLastItem(){
      const last_item = this.$refs.last_reasoning_item?.$el
      if (last_item) this.scrollToItem(last_item)
    }
  }
}
